import React from 'react';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { PartnerDetails } from 'apis/PartnerApi';
import { FormattedMessage } from 'react-intl';

type MergeResultStepProps = {
    error: string;
    message: string;
    onClose: () => void;
    onRetry: () => void;
    sourcePartner: PartnerDetails;
    success: boolean;
    targetPartner: PartnerDetails;
};

export const MergeResultStep = (props: MergeResultStepProps) => {

    const { error, message, onClose, onRetry, sourcePartner, success, targetPartner } = props;

    return (
        <div className="merge-result-step mt-3">
            {success ? (
                <>
                    <div className="text-center py-3">
                        <i className="fa-solid fa-circle-check fa-3x text-success mb-2" />
                        <h4 className="text-success">
                            {<FormattedMessage defaultMessage="Merge Completed Successfully" id="merge_completed_successfully.c0dd0acd" /> || 'Merge Completed Successfully'}
                        </h4>
                    </div>

                    <div className="merge-review-card merge-review-card--source mt-3">
                        <div className="merge-review-card__header merge-review-card__header--source">
                            <i className="fa-solid fa-building me-2" />
                            {sourcePartner.Name}
                            <span className="merge-review-card__badge merge-review-card__badge--keeping">
                                {<FormattedMessage defaultMessage="Active" id="active.b9616c88" /> || 'Active'}
                            </span>
                        </div>
                        <div className="merge-review-card__body">
                            <div className="merge-review-card__field">
                                <span className="merge-review-card__label">

                                    <FormattedMessage defaultMessage="ID" id="id.e9650a61" />
                                </span>
                                <span className="merge-review-card__value">
                                    {sourcePartner.ID}
                                </span>
                            </div>
                            <div className="merge-review-card__field">
                                <span className="merge-review-card__label">
                                    {<FormattedMessage defaultMessage="Email" id="email.500d9e86" /> || 'Email'}
                                </span>
                                <span className="merge-review-card__value">
                                    {sourcePartner.ContactEmail || '—'}
                                </span>
                            </div>
                            <div className="merge-review-card__field">
                                <span className="merge-review-card__label">
                                    <FormattedMessage defaultMessage="Merged With" id="merged_with.9d2463ff" />
                                </span>
                                <span className="merge-review-card__value">
                                    <FormattedMessage
                                        defaultMessage="{name} (ID: {id})" id="name_id_id.74f31354"
                                        values={{ id: targetPartner.ID, name: targetPartner.Name }}
                                    />
                                </span>
                            </div>
                        </div>
                    </div>

                    {message && (
                        <div className="alert alert-warning mt-3 d-flex align-items-start">
                            <i className="fa-solid fa-triangle-exclamation me-2 mt-1" />
                            <div>
                                <strong>
                                    {<FormattedMessage defaultMessage="Warning" id="warning.64b35335" /> || 'Notice'}
                                </strong>
                                <p className="mb-0 mt-1">
                                    {message}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="text-center mt-4">
                        <GMetrixButton
                            onClick={onClose}
                            variant="primary"
                        >
                            {<FormattedMessage defaultMessage="Close" id="close.99e01fb5" /> || 'Close'}
                        </GMetrixButton>
                    </div>
                </>
            ) : (
                <>
                    <div className="text-center py-3">
                        <i className="fa-solid fa-circle-xmark fa-3x text-danger mb-2" />
                        <h4 className="text-danger">
                            {<FormattedMessage defaultMessage="Merge was Unsuccessful" id="merge_was_unsuccessful.b2f1fed5" /> || 'Merge was Unsuccessful'}
                        </h4>
                        <p className="text-muted mt-2">
                            <FormattedMessage
                                values={{
                                    b: chunks => (
                                        <strong>
                                            {chunks}
                                        </strong>
                                    ),
                                    sourceName: sourcePartner.Name,
                                    targetName: targetPartner.Name
                                }} defaultMessage="The merge of <b>{targetName}</b> → <b>{sourceName}</b> could not be completed."
                                id="the_merge_of_targetname_sourcename_could.738432d6"
                            />
                        </p>
                    </div>

                    {error && (
                        <div className="alert alert-danger mt-3 d-flex align-items-start">
                            <i className="fa-solid fa-circle-exclamation me-2 mt-1" />
                            <div>
                                <strong>
                                    {<FormattedMessage defaultMessage="Error" id="error.e50d69ad" /> || 'Error Details'}
                                </strong>
                                <p className="mb-0 mt-1" style={{ wordBreak: 'break-word' }}>
                                    {error}
                                </p>
                            </div>
                        </div>
                    )}

                    <div className="mt-4 d-flex gap-2 justify-content-center">
                        <GMetrixButton
                            onClick={onRetry}
                            variant="outline-primary"
                        >
                            <i className="fa-solid fa-rotate-left me-1" />
                            {<FormattedMessage defaultMessage="Retry" id="retry.225ca180" /> || 'Retry'}
                        </GMetrixButton>
                        <GMetrixButton
                            onClick={onClose}
                            variant="outline-secondary"
                        >
                            {<FormattedMessage defaultMessage="Close" id="close.99e01fb5" /> || 'Close'}
                        </GMetrixButton>
                    </div>
                </>
            )}
        </div>
    );

};
